// ==================================================================
// PLEASE DO NOT EDIT THIS FILE, REACH ME OUT IF YOU FACE ANY ISSUE [TEO]
// ==================================================================

const projectEnvironment = process.env.REACT_APP_ENV_ENVIRONMENT;

// In local environments the localhost using port 3000 is the default selected signout/signin url.
const envRedirectSignIn = {
    dev: ["https://dev.dwipgs59hzgzw.amplifyapp.com"],
    qa: ["https://qa.d1oyosul9ic5l.amplifyapp.com"],
    prod: ["https://gam.epta-service.com"]
}
const envredirectSignOut = {
    dev: ["https://dev.dwipgs59hzgzw.amplifyapp.com"],
    qa: ["https://qa.d1oyosul9ic5l.amplifyapp.com"],
    prod: ["https://gam.epta-service.com"]
}

const envDomain = {
  dev: ["telemonitoring-userpool-qa.auth.eu-central-1.amazoncognito.com"],
  qa: ["telemonitoring-userpool-qa.auth.eu-central-1.amazoncognito.com"],
  prod: ["tlm-user-pool.auth.eu-central-1.amazoncognito.com"]
}

const redirectSignIn = projectEnvironment ? envRedirectSignIn[projectEnvironment] : null;
const redirectSignOut = projectEnvironment ? envredirectSignOut[projectEnvironment] : null;
const domain = projectEnvironment ? envDomain[projectEnvironment] : null;

const customConfig = {
    "oauth": {
        "domain": domain ? domain : envDomain['dev'], // <-- By default, the dev environment is selected.
        "scope": [
            "email",
            "openid",
            "profile"
        ],
        "redirectSignIn": `http://localhost:3000,${redirectSignIn ? redirectSignIn.join(",") : ""}`,
        "redirectSignOut": `http://localhost:3000,${redirectSignOut ? redirectSignOut.join(",") : ""}`,
        "responseType": "code"
    },
};

console.log("this is the print of custom-config.js file in order to debug the redirect URIs: ", customConfig);

export default customConfig;